import { render, staticRenderFns } from "./keperluanmodal.vue?vue&type=template&id=20e89487&"
import script from "./keperluanmodal.vue?vue&type=script&lang=js&"
export * from "./keperluanmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports